export default function MessageTickCircleIcon() {
  return (
    <>
      <circle cx='42' cy='42' r='42' fill='#FBF3F2' />
      <path
        d='M28 45C23.58 45 20 48.58 20 53C20 54.5 20.42 55.92 21.16 57.12C22.54 59.44 25.08 61 28 61C30.92 61 33.46 59.44 34.84 57.12C35.58 55.92 36 54.5 36 53C36 48.58 32.42 45 28 45ZM31.94 52.34L27.68 56.28C27.4 56.54 27.02 56.68 26.66 56.68C26.28 56.68 25.9 56.54 25.6 56.24L23.62 54.26C23.04 53.68 23.04 52.72 23.62 52.14C24.2 51.56 25.16 51.56 25.74 52.14L26.7 53.1L29.9 50.14C30.5 49.58 31.46 49.62 32.02 50.22C32.58 50.82 32.54 51.78 31.94 52.34Z'
        fill='#A0383F'
      />
      <path
        d='M52.5 22.8604H33.5C27.8 22.8604 24 26.6604 24 32.3604V41.2804C24 41.9804 24.72 42.4804 25.4 42.3004C26.24 42.1003 27.1 42.0004 28 42.0004C33.72 42.0004 38.44 46.6404 38.96 52.2603C39 52.8203 39.46 53.2603 40 53.2603H41.1L49.56 58.9004C50.8 59.7404 52.5 58.8204 52.5 57.3004V53.2603C55.34 53.2603 57.72 52.3004 59.38 50.6604C61.04 48.9804 62 46.6004 62 43.7604V32.3604C62 26.6604 58.2 22.8604 52.5 22.8604ZM49.66 39.6204H36.34C35.56 39.6204 34.92 38.9804 34.92 38.2004C34.92 37.4004 35.56 36.7604 36.34 36.7604H49.66C50.44 36.7604 51.08 37.4004 51.08 38.2004C51.08 38.9804 50.44 39.6204 49.66 39.6204Z'
        fill='#A0383F'
      />
    </>
  );
}
